import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { Logger, LogLevel } from "msal";
import { canUseDOM } from "../utils";
const config = require("../temp/config");

// The auth provider should be a singleton. Best practice is to only have it ever instantiated once.
// Avoid creating an instance inside the component it will be recreated on each render.
// If two providers are created on the same page it will cause authentication errors.
export const authProvider = canUseDOM()
  ? new MsalAuthProvider(
      {
        auth: {
          authority: "https://login.microsoftonline.com/common/",
          clientId: config.webSettings?.o365ClientId,
          postLogoutRedirectUri: canUseDOM() ? `${window.location.origin}/${window.location.pathname.split("/")[1]}` : "",
          redirectUri: canUseDOM() ? `${window.location.href}` : "",

          // After being redirected to the "redirectUri" page, should user
          // be redirected back to the Url where their login originated from?
          navigateToLoginRequestUrl: false
        },
        // Enable logging of MSAL events for easier troubleshooting.
        // This should be disabled in production builds.
        system: {
          logger: new Logger(
            (logLevel, message, containsPii) => {
              //   console.log("[MSAL]", message);
            },
            {
              level: LogLevel.Verbose,
              piiLoggingEnabled: false
            }
          )
        },
        cache: {
          cacheLocation: "sessionStorage",
          storeAuthStateInCookie: true
        }
      },
      {
        scopes: ["openid"]
      },
      {
        loginType: LoginType.Redirect,
        // When a token is refreshed it will be done by loading a page in an iframe.
        // Rather than reloading the same page, we can point to an empty html file which will prevent
        // site resources from being loaded twice.
        tokenRefreshUri: canUseDOM() ? window.location.origin + "/auth.html" : ""
      }
    )
  : {};
